import Loadable from 'react-loadable';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const SignupPageContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "SignupPageContainer" */
      './SignupPageContainer.dynamic'
    ),
  loading: LoadingPageLoadable,
});
